import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

function LiveViews({ pageId }) {
  const [count, setCount] = useState(0);

  const admin = useSelector((state) => state.user.admin);

  const apiSocketUrl = process.env.REACT_APP_API_SOCKET_URL;

  const getSocketUrl = () => {
    const rawUrl = String(apiSocketUrl || "").trim();
    if (!rawUrl) return null;

    if (rawUrl.startsWith("ws://") || rawUrl.startsWith("wss://")) {
      return rawUrl;
    }

    if (rawUrl.startsWith("http://")) {
      return rawUrl.replace("http://", "ws://");
    }

    if (rawUrl.startsWith("https://")) {
      return rawUrl.replace("https://", "wss://");
    }

    const secure = window.location.protocol === "https:";
    return `${secure ? "wss" : "ws"}://${rawUrl}`;
  };

  useEffect(() => {
    const socketUrl = getSocketUrl();
    if (!socketUrl) return;

    const ws = new WebSocket(socketUrl);
    // const ws = new WebSocket("ws://192.168.0.194:2323");

    ws.onopen = () => {
      ws.send(JSON.stringify({ pageId }));
    };

    ws.onmessage = (e) => {
      const data = JSON.parse(e.data);
      if (data.pageId === pageId) setCount(data.count);
    };

    return () => ws.close();
  }, [pageId, apiSocketUrl]);

  // if (pageId === 'Blackbaton') {
  //   return <p>{count} people are viewing this page now</p>
  // }

  if (admin !== '1') return null

  return <p className="text-[.75rem] font-dmSans">{count > 0 ? count : ''}
  </p>;
}

export default LiveViews;
